export default function XIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="38.867" height="39.789" viewBox="0 0 38.867 39.789">
    <g id="imggal_x" transform="translate(0.97 1.268)">
      <line id="Linie_44" data-name="Linie 44" y1="37" x2="36" transform="translate(0.464 0.127)" fill="none" stroke="#fff" stroke-width="4"/>
      <line id="Linie_45" data-name="Linie 45" x1="36" y1="37" transform="translate(0.464 0.127)" fill="none" stroke="#fff" stroke-width="4"/>
    </g>
  </svg>;
}